import { createContext, useContext } from "react";
import { User } from "~/application/types";

export type AuthSignInData = {
  user: User;
  storeTokenLocally?: boolean;
  authToken: {
    value?: string;
    createdAt?: Date;
  };
};

export type SignInParams = {
  email: string;
  password: string;
  keepSigned: boolean;
  securityKey: string;
};

export type AuthContextType = {
  user: User;
  authToken: AuthSignInData["authToken"];
  isSigned: boolean;
  isLoading: boolean;
  qrCodeUrl?: string | null;
  saveAuthToken: (data: AuthSignInData) => void;
  signIn: (data: SignInParams, onErrorAttempt?: () => void) => Promise<void>;
  signOut: () => void;
  attempts: number;
};


export const AuthContext = createContext({} as AuthContextType);

export const useAuth = () => useContext(AuthContext);
